// frontend/src/DesignTab/pixpolygonSelectors.ts (eller var du har selectors)
import { createSelector } from "@reduxjs/toolkit";
import { PostMcbimItemsApiResponse } from "../../openapi";
import { IMmiLegendStat } from "./pixpolygonSelectors";
import { selectMcBimItemsForViewer } from "../McBim/mcbimItemSelectors";

export const selectMmiLegendStatsForArkItems = createSelector(
  [selectMcBimItemsForViewer],
  (items): IMmiLegendStat[] => {
    if (items == null || items.length === 0) {
      return [];
    }

    // mmi -> { total, byClass }
    const map = new Map<number, { total: number; byClass: Record<string, number> }>();

    for (const item of items as PostMcbimItemsApiResponse) {
      const rawMmi = item.mmi;
      if (rawMmi == null) continue;

      const mmi = typeof rawMmi === "number" ? rawMmi : Number(String(rawMmi).trim());
      if (!Number.isFinite(mmi)) continue;

      const cls = (item.instanceClass ?? "UNKNOWN") as string;

      let entry = map.get(mmi);
      if (!entry) {
        entry = { total: 0, byClass: {} };
        map.set(mmi, entry);
      }

      entry.total += 1;
      entry.byClass[cls] = (entry.byClass[cls] ?? 0) + 1;
    }

    return Array.from(map.entries())
      .map(([mmi, v]) => ({
        mmi,
        total: v.total,
        byClass: v.byClass,
      }))
      .sort((a, b) => a.mmi - b.mmi);
  }
);

export type IMmiDistributionRow = {
  mmi: number;
  count: number;
  percent: number; // 0..100
};

export type IMmiDistribution = {
  total: number;
  rows: IMmiDistributionRow[]; // sorted by mmi ascending
};

export const selectMmiDistributionForArkItems = createSelector(
  [selectMmiLegendStatsForArkItems],
  (stats): IMmiDistribution => {
    if (stats.length === 0) {
      return { total: 0, rows: [] };
    }

    const total = stats.reduce((sum, s) => sum + (s.total ?? 0), 0);
    if (total <= 0) {
      return { total: 0, rows: [] };
    }

    const rows = stats
      .map((s) => ({
        mmi: s.mmi,
        count: s.total,
        percent: (s.total / total) * 100,
      }))
      .sort((a, b) => a.mmi - b.mmi);

    return { total, rows };
  }
);
